export { WidgetsBlock } from './widgets-block';
